/*
 *  Copyright (C) 2017 Atelier Cartographique <contact@atelier-cartographique.be>
 *
 *  This program is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, version 3 of the License.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import debug from 'debug';
import { displayException } from 'sdi/app';
import 'sdi/polyfill';
import { defaultShape } from 'sdi/shape';
import { configure } from 'sdi/shape/functions';
import type { IShape } from 'sdi/shape/types';
import { AppConfigIO, source } from 'sdi/source';
import { validate } from 'sdi/source/validation';
import App from './app';
import './locale';
import './shape';

const logger = debug('sdi:index');

export const main = (SDI: unknown) => {
    validate(AppConfigIO, SDI).fold(displayException, config => {
        try {
            const start = source<IShape>(['app/lang']);
            const store = start({
                ...defaultShape(config),
                'app/codename': 'dashboard',
                'app/lang': 'fr',
                'app/layout': ['Dashboard'],
                'component/button': {},
            });
            configure(store);
            const app = App(store);
            logger('start rendering');
            app();
        } catch (err) {
            displayException(`${err}`);
        }
    });
};

logger('loaded');
